import { m } from '~/paraglide/messages'
import { language, platform } from '~/params'
import { native } from '@forest/native-services'

export function LearnMoreButton() {
  return (
    <button
      className="relative flex items-center gap-1 text-white/60"
      onClick={() => {
        native.general.logEvent({
          event_name: 'component_event',
          event_params: {
            type: 'btn',
            app_action: 'click',
            component_name: 'relax_paywall_more_features',
          },
        })
        let subscriptionDetailsPageURL: string
        switch (import.meta.env.MODE) {
          case 'staging':
            subscriptionDetailsPageURL = `https://forest-permanent-paywall-staging.seekrtech.com/${language}/details/`
            break
          case 'production':
            subscriptionDetailsPageURL = `https://forest-permanent-paywall.seekrtech.com/${language}/details/`
            break
          default:
            subscriptionDetailsPageURL = `https://forest-permanent-paywall.seekrtech.com/${language}/details/`
            break
        }
        location.href = `${subscriptionDetailsPageURL}?platform=${platform}`
      }}
    >
      <p className="text-center text-xs">{m.learn_more()}</p>

      <span className="block size-3">
        <svg
          className="size-full"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.45312 9.96004L7.71313 6.70004C8.09813 6.31504 8.09813 5.68504 7.71313 5.30004L4.45312 2.04004"
            stroke="currentColor"
            strokeWidth="1"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  )
}
